/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArcHospiDto } from '../../models/arc-hospi-dto';

export interface ArcHospiPut$Params {
      body?: ArcHospiDto
}

export function arcHospiPut(http: HttpClient, rootUrl: string, params?: ArcHospiPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ArcHospiDto>> {
  const rb = new RequestBuilder(rootUrl, arcHospiPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArcHospiDto>;
    })
  );
}

arcHospiPut.PATH = '/v1/ArcHospi/Put';
